import images from "./images-compressed.js";
import prices from "./price-point.js";
export default [{
  key: 'silhouette',
  heading: {
    title: 'Which silhouettes do you like?',
    subtitle: 'Choose 2 to 6 photos that fit your vibe.'
  },
  options: images.silhouette
}, {
  key: 'neckline',
  heading: {
    title: 'Which necklines feel like you?',
    subtitle: 'Choose 2 to 6 favorite photos.'
  },
  options: images.neckline
}, {
  key: 'sleeves',
  heading: {
    title: 'Lovely! How about the sleeves?',
    subtitle: 'Choose 2 to 6 photos in your style.'
  },
  options: images.sleeves
}, {
  filterKey: 'gownLength',
  key: 'dress-length',
  heading: {
    title: 'Okay, and what about length?',
    subtitle: 'Choose 2 to 6 photos you like most.'
  },
  options: images.gown_length
}, {
  filterKey: 'pricePoint',
  key: 'price',
  heading: {
    title: 'Do you have a budget in mind?',
    subtitle: 'On average, a wedding dress costs $2,000 in the US but it varies by design and more.'
  },
  options: prices
}];